module.exports = __webpack_public_path__ + "img/2中文.1b1ba067.png";